import type { LinearProgressBarProps as LinearProgressBarCoreProps } from './LinearProgressBarCore';

export type LinearProgressBarSkin =
  | 'standard'
  | 'success'
  | 'warning'
  | 'premium'
  | 'neutral';

export type LinearProgressBarPadding = 'none';
export type LinearProgressBarHeight = 'none';

export interface LinearProgressBarProps extends Pick<
  LinearProgressBarCoreProps,
  | 'error'
  | 'showProgressIndication'
  | 'label'
  | 'value'
  | 'min'
  | 'max'
  | 'precision'
  | 'prefixIndication'
  | 'onClick'
  | 'aria-label'
  | 'aria-hide-affixes'
  | 'role'
> {
  /** Hook for testing purposes. */
  dataHook?: string;

  /** Message to display when an error happens. */
  errorMessage?: string;

  /** Use light theme instead of dark theme. */
  light?: boolean;

  /** Sets the skin of the Linear Progress Bar.
   * @default standard
   */
  skin?: LinearProgressBarSkin;

  /** Overrides the default padding. Options: 'none'. */
  padding?: LinearProgressBarPadding;

  /** Overrides the default height. Options: 'none'. */
  height?: LinearProgressBarHeight;
}
